// access ws-inv-data proxy to fetch dealer DR admin configs
// returns config || empty object when there is an error
export default async (mmdId) => {
    let drAdminConfig;
    try {
        const response = await fetch(`/api/widget/ws-inv-data/getDealerDRConfig/${mmdId}`, {
            method: 'GET',
            credentials: 'omit',
            headers: {
                'Accept': 'application/json',
            }
        });
        drAdminConfig = await response.json();
    } catch (err) {
        // eslint-disable-next-line
        console.error('DR ADMIN CONFIG REQUEST FAILED: ', err);
        drAdminConfig = {};
    }
    return drAdminConfig;
}